// extracted by mini-css-extract-plugin
module.exports = {"consumerHeaderSearchBar":"ConsumerHeaderSearchBar_consumerHeaderSearchBar__wDD2P","withSearchDropdown":"ConsumerHeaderSearchBar_withSearchDropdown__WD6CP"};